<template>
  <div>
    <a-row>
      <g-master name="forms"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                ref="master"
                :parentData="parentData"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Item')">
                <a-input
                  v-decorator="['item', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Descripción')">
                <a-input
                  v-decorator="['description', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Tipo')">
                <a-input
                  v-decorator="['type', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Path')">
                <a-input
                  v-decorator="['path', { rules: [{ required: false}] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Path taskflow')">
                <a-input
                  v-decorator="['path_taskflow', { rules: [{ required: false}] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Priority')">
                <a-input-number v-bind="fiOptions" style="width: 100%"
                                v-decorator="['priority', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Taskflow')">
                <a-input
                  v-decorator="['taskflow', { rules: [{ required: false}] }]"/>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="ACCIÓN NIVEL 1" key="1">
          <mantenimiento-node-action v-if="idForm" :item="idForm"></mantenimiento-node-action>
          <span v-else>Seleccione un nodo para ver más.</span>
        </a-tab-pane>
        <a-tab-pane tab="NODO NIVEL 2" key="2">
          <mantenimiento-node-children v-if="idForm" :item="idForm"></mantenimiento-node-children>
          <span v-else>Seleccione un nodo para ver más.</span>
        </a-tab-pane>
      </a-tabs>
    </a-row>
    <a-row>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        period_request: {h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true},
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'node',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'item'
            },
            columns: [
              {title: 'Item', dataIndex: 'item', sorter: true},
              {title: 'Descripción', dataIndex: 'description', sorter: true},
              {title: 'Path', dataIndex: 'path', sorter: true},
              {title: 'Prioridad', dataIndex: 'priority', sorter: true},
              {title: 'Tipo', dataIndex: 'type', sorter: true},
              {title: 'Taskflow', dataIndex: 'taskflow', sorter: true},
              {title: 'Path taskflow', dataIndex: 'path_taskflow', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'item'},
            {name: 'description'},
            {name: 'path'},
            {name: 'path_taskflow'},
            {name: 'priority'},
            {name: 'taskflow'},
            {name: 'type'}
          ]
        }
      }
    },
    computed: {
      idForm () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].item : null
      },

      parentData () {
        return {filter_parent_node: true}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/User/Node.vue